'use client';
import { useEffect } from 'react';

interface InstagramEmbedsProps {
  postUrls: string[];
}

declare global {
  interface Window {
    instgrm?: {
      Embeds: { process: () => void };
    };
  }
}

export default function InstagramFeed({ postUrls }: InstagramEmbedsProps) {
  // 注意：Instagram 公式埋め込みのロジックには触らない（spec 指示）
  useEffect(() => {
    const SCRIPT_ID = 'instagram-embed-script';
    const process = () => window.instgrm?.Embeds.process();

    if (document.getElementById(SCRIPT_ID)) {
      process();
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    script.onload = process;
    document.body.appendChild(script);
  }, [postUrls]);

  if (postUrls.length === 0) {
    return (
      <div className="panel-screenshot text-center">
        <p className="text-body text-ink-muted">
          Instagram 投稿を読み込み中です。
        </p>
        <p className="mt-2 text-caption text-ink-tertiary">
          埋め込み投稿は後日選定して並べます。
        </p>
        <a
          href="https://www.instagram.com/napa_himeru"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-5 btn-secondary"
        >
          Instagram プロフィールを開く →
        </a>
      </div>
    );
  }

  // Linear panel rhythm に合わせて charcoal panel に Instagram 埋め込みを収める
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6">
      {postUrls.map((url) => (
        <div key={url} className="panel-screenshot p-3 sm:p-4">
          <blockquote
            className="instagram-media !min-w-0 !w-full !m-0 !rounded-md overflow-hidden"
            data-instgrm-permalink={url}
            data-instgrm-version="14"
          />
        </div>
      ))}
    </div>
  );
}
